import {CLEAN_VERIFIED_FILES} from "../types";

export const cleanVerifiedFiles= () => {
  return({type: CLEAN_VERIFIED_FILES, payload: {verifiedFilesList: {entries: []}}});
};
export default cleanVerifiedFiles;